const useOrderedBarChartData = (reportData) => {
  const chartData = reportData.values.reduce((data, value) => {
    const { rank, optionId, count, percentage } = value;
    if (!data[rank]) {
      // eslint-disable-next-line no-param-reassign
      data[rank] = {
        label: String(rank + 1),
        values: {},
      };
    }

    // eslint-disable-next-line no-param-reassign
    data[rank].values[optionId] = { count, percentage };

    return data;
  }, []);

  const tooltipAttributes = reportData.options.reduce(
    (attributes, { id, label }) => [
      ...attributes,
      {
        tooltipLabel: label,
        payloadKey: ['values', id, 'count'],
      },
      {
        tooltipLabel: label,
        payloadKey: ['values', id, 'percentage'],
        percentage: true,
      },
    ],
    []
  );

  return { chartData, tooltipAttributes };
};

export default useOrderedBarChartData;
